var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductNamo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 201,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "#000F9F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4097_4563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.7667 5.65273L14.8225 5.70532L14.8503 4.71143L13.1447 5.92356C12.6662 6.19832 12.3455 6.71105 12.3482 7.29739L12.4741 37.5849C12.478 38.4578 13.1937 39.1625 14.075 39.1598L27.9059 39.1033C28.1656 39.1033 28.4108 39.0376 28.6268 38.9272C28.7567 38.8614 28.8747 38.7773 28.9807 38.68L30.6651 37.5047L29.4909 37.0906L29.3664 7.22771C29.3624 6.35477 28.6467 5.6501 27.7654 5.65273H27.7667Z",
    fill: "#6674FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6805 37.8492L15.8497 37.9057C14.9697 37.9097 14.2527 37.205 14.2487 36.3307L14.1228 6.04326C14.1188 5.17032 14.8292 4.45908 15.7105 4.45514L29.5414 4.39992C30.4214 4.39597 31.1384 5.10064 31.1423 5.9749L31.2682 36.2624C31.2722 37.1353 30.5619 37.8466 29.6805 37.8505V37.8492Z",
    fill: "#B8BEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6949 36.505L21.5091 36.5199C21.2947 36.5199 21.1201 36.3269 21.1201 36.0894C21.1201 35.8498 21.2928 35.6547 21.5053 35.6547L24.6911 35.6399C24.9056 35.6399 25.0801 35.8329 25.0801 36.0704C25.0801 36.31 24.9074 36.505 24.6949 36.505Z",
    stroke: "#F5F6FF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.356 33.7182C30.3583 34.271 29.9116 34.7208 29.3587 34.7223L16.5116 34.7573C15.9599 34.7588 15.5112 34.3131 15.5089 33.7614L15.4043 8.52176C15.402 7.96892 15.8487 7.51912 16.4016 7.51762L29.2487 7.48269C29.8004 7.4812 30.2491 7.92682 30.2514 8.47855L30.356 33.7182Z",
    fill: "#F5F6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5488 6.6963L20.5119 6.7055C20.3622 6.7055 20.2402 6.58587 20.2402 6.43862C20.2402 6.29007 20.3608 6.16911 20.5093 6.16911L24.5461 6.15991C24.6959 6.15991 24.8178 6.27955 24.8178 6.42679C24.8178 6.57535 24.6972 6.6963 24.5488 6.6963Z",
    fill: "#F5F6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9707 6.21381C25.9751 6.21328 25.9796 6.21287 25.9842 6.2126C25.9881 6.21285 25.992 6.2132 25.9958 6.21366C25.9967 6.21376 25.9976 6.21387 25.9985 6.21398C26.1034 6.22766 26.1977 6.31737 26.199 6.44266C26.199 6.44353 26.199 6.44441 26.199 6.44529C26.199 6.56171 26.1125 6.65893 25.9985 6.67381C25.9976 6.67392 25.9967 6.67403 25.9958 6.67414C25.9914 6.67467 25.9869 6.67508 25.9823 6.67535C25.9784 6.6751 25.9745 6.67475 25.9707 6.67429C25.9698 6.67419 25.9689 6.67408 25.968 6.67397C25.8631 6.66029 25.7688 6.57058 25.7675 6.44529C25.7675 6.44441 25.7675 6.44354 25.7675 6.44266C25.7675 6.32624 25.854 6.22902 25.968 6.21414C25.9689 6.21402 25.9698 6.21391 25.9707 6.21381Z",
    fill: "#F5F6FF",
    stroke: "#F5F6FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4097_4563"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.92,
    height: 34.76,
    fill: "white",
    transform: "translate(12.3481 4.3999)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductNamo);
export default __webpack_public_path__ + "static/media/product_namo.df42b41c091fcb6e49090c354d6f893d.svg";
export { ForwardRef as ReactComponent };